import { useId } from "react";

import { Button } from "./Button";
import { Modal, ModalBody, ModalFooter } from "./Modal";

export function ConfirmDialog({
  title,
  description,
  confirmLabel,
  cancelLabel = "Cancel",
  busy = false,
  onCancel,
  onConfirm,
}: {
  title: string;
  description: string;
  confirmLabel: string;
  cancelLabel?: string;
  busy?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  const id = useId();
  const titleId = `${id}-title`;
  const descriptionId = `${id}-description`;
  return (
    <Modal
      size="confirm"
      role="alertdialog"
      ariaLabelledBy={titleId}
      ariaDescribedBy={descriptionId}
      onClose={onCancel}
    >
      <ModalBody className="ui-confirm-dialog__body">
        <h2 id={titleId}>{title}</h2>
        <p id={descriptionId}>{description}</p>
      </ModalBody>
      <ModalFooter>
        <Button tone="quiet" disabled={busy} onClick={onCancel}>
          {cancelLabel}
        </Button>
        <Button tone="danger" disabled={busy} onClick={onConfirm}>
          {busy ? "Working…" : confirmLabel}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
